import FacebookLoader from './facebook-loader.jquery.js';
import debounce from 'lodash/debounce';

;(function($, window, document, undefined) {

  const pluginName = 'fbComments';

  class FacebookComments {

    constructor(element, options) {

      this._name = pluginName;
      this._defaults = $.fn[pluginName].defaults;

      this.element = element;
      this.options = $.extend({}, this._defaults, options);

      this.init();

    }

    init() {
      this.loader = new FacebookLoader(this.options.loaderItems);
      this.cacheElements();
      this.bindEvents();
    }

    cacheElements() {
      this.$element = $(this.element);
    }

    bindEvents() {
      $(document).on(pluginName + ':render', this.render.bind(this));
      window.FB.Event.subscribe('xfbml.render', this.finishLoading.bind(this));

      if (!this.options.disableScroll) {
        this.scrollListener = debounce(this.scrollHandler.bind(this), 200);
        $(window).on('scroll', this.scrollListener);
      } else {
        this.render();
      }
    }

    scrollHandler() {

      var winBottom = $(window).scrollTop() + $(window).height();
      var elTop = this.$element.offset().top;

      if (elTop < winBottom) {
        this.render();
      }

    }

    startLoading() {
      this.$element.prepend(this.loader.$element);
    }

    finishLoading() {

      if (!this.$element.data('rendered')) {
        return;
      }

      if (!this.options.disableScroll) {
        $(window).off('scroll', this.scrollListener);
      }

      this.loader.$element.remove();

    }

    render() {
      this.startLoading();
      this.$element.data('rendered', true);
      window.FB.XFBML.parse(this.$element[0]);
    }

  }

  $.fn[pluginName] = function(options) {
    return this.each(function() {
      if (!$.data(this, `plugin_${pluginName}`)) {
        $.data(this, `plugin_${pluginName}`, new FacebookComments(this, options));
      }
    });
  };

  $.fn[pluginName].defaults = {
    loaderItems: 1,
    disableScroll: false
  };

})(jQuery, window, document);
